import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { ColumnHeading } from "../../shared/components/TableElements";
import { useTranslation } from "react-i18next";
import { Card, CardBody } from "../../shared/components/Card";
import { useState } from "react";
import { postApi } from "../../api/getUser";
import { getDisplayDate } from "../../shared/helpers";
import styled from "styled-components";
import ExistingPlan from "./ExistingPlan";
import NewPlan from "./NewPlan";
import { TableSpinner } from "../../shared/components/table/components/ReactTableConstructor";
import { useAuth } from "../../contexts/AuthContext";
import useQuery from "../../shared/custom-hooks/useQuery";
import { useHistory } from "react-router";
import InfoPopup from "../../shared/components/InfoPopup";
import PaymentProcessingPopup from "../../shared/components/PaymentProcessingPopup";
import getUnixTime from "date-fns/getUnixTime";

const Billing = () => {
  const { t } = useTranslation("common");

  const { isLoggedIn, setTag, setIsFreePlan } = useAuth();

  const [subscriptionData, setSubscriptionData] = useState(null);
  const [perVehiclePrice, setPerVehiclePrice] = useState({
    essential: 0,
    advanced: 0,
  });
  const [totalPrice, setTotalPrice] = useState({ essential: 0, advanced: 0 });
  const [priceDetailsData, setPriceDetailsData] = useState(null);
  const [topUpPriceDetails, setTopUpPriceDetails] = useState(null);
  const [noOfVehicles, setNoOfVehicles] = useState(5);

  const [paymentData, setPaymentData] = useState(null);
  const [equipmentPaymentData, setEquipmentPaymentData] = useState(null);
  //const [telematicsData, setTelematicsData] = useState(null);

  const [subPaymentData, setSubPaymentData] = useState(null);
  const [equipmentSubscriptionData, setEquipmentSubscriptionData] =
    useState(null);

  const [invoices, setInvoices] = useState([]);
  const [receipts, setReceipts] = useState([]);

  const [loading, setLoading] = useState(true);

  const [toggleValue, setToggleValue] = useState("monthly");
  const [trialUser, setTrialUser] = useState(false);
  const [isLegacyPricing, setIsLegacyPricing] = useState(false);

  const history = useHistory();
  const query = useQuery();
  const status = query.get("status");
  const is_topup = query.get("is_topup");

  const removeQueryParams = (...params) => {
    const searchParams = new URLSearchParams(window.location.search);
    params.forEach((p) => searchParams.delete(p));
    history.replace({ search: searchParams.toString() });
  };
  const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);
  const [subscriptionPopupData, setSubscriptionPopupData] = useState({
    message: t("sub_success_msg"),
    icon: { className: "fi fi-rs-check-circle", color: "green" },
  });

  // Payment processing popup states
  const [showPaymentProcessingPopup, setShowPaymentProcessingPopup] =
    useState(false);
  const [paymentProcessingData, setPaymentProcessingData] = useState({
    message: t("payment_processing"),
    icon: { className: "fi fi-rs-loader", color: "blue" },
  });
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    if (isLoggedIn) {
      if (status && !is_topup) {
        if (status === "success") {
          setSubscriptionPopupData({
            message: t("sub_success_msg"),
            icon: { className: "fi fi-rs-check-circle", color: "green" },
          });
          setShowSubscriptionPopup(true);
          pollForNewPlan();
        } else if (status === "failed") {
          setSubscriptionPopupData({
            message: t("sub_failure_msg"),
            icon: { className: "fi fi-rr-cross-circle", color: "red" },
          });
          setShowSubscriptionPopup(true);
          billingCalls();
        }
      } else {
        billingCalls();
      }
    }
  }, [isLoggedIn]);

  const pollSubscriptionStatus = async (
    predicate,
    maxAttempts = 5,
    intervalMs = 4000,
    onSuccess,
  ) => {
    setLoading(true);
    for (let i = 0; i < maxAttempts; i++) {
      await new Promise((res) => setTimeout(res, intervalMs));
      try {
        const subRes = await postApi(
          { querystring: "get_subscription_status" },
          "subscription",
        );
        if (subRes.success) {
          const { success, ...subscription_data } = subRes;
          if (predicate(subscription_data)) {
            setSubscriptionData(subscription_data);

            //Update tag
            let tag = "free-user";
            const { subscription_status, product } = subscription_data;
            if (subscription_status == "paid" && product == 5) {
              tag = "essential-user";
            } else if (subscription_status == "paid") {
              tag = "advanced-user";
            } else {
              tag = "free-user";
            }

            if (tag === "free-user") {
              setIsFreePlan(true);
            }
            setTag(tag);

            //set invoices and receipts
            const invoiceRes = await postApi(
              { querystring: "get_invoice_details" },
              "subscription",
            );
            console.log("invoiceRes", invoiceRes);
            if (invoiceRes.success) {
              const {
                subscription_payment_data,
                equipment_subscription_payment_data,
              } = invoiceRes;
              setSubPaymentData(subscription_payment_data);
              setEquipmentSubscriptionData(equipment_subscription_payment_data);
              setIsLegacyPricing(
                !!subscription_payment_data?.is_legacy_pricing,
              );
              const invoiceData = invoiceRes.invoices;
              setInvoices(invoiceData);
              setReceipts(invoiceRes.charges);
            }

            setLoading(false);
            onSuccess?.();
            return;
          }
        }
      } catch (e) {
        console.error("Polling error:", e);
      }
    }
    // Predicate never matched within timeout — fall back to full reload
    window.location.reload();
  };

  const billingCalls = async () => {
    try {
      setLoading(true);
      let legacyFlag = false;
      const subRes = await postApi(
        {
          querystring: "get_subscription_status",
        },
        "subscription",
      );
      if (subRes.success) {
        console.log("subRes", subRes);
        const { success, ...subscription_data } = subRes;
        setSubscriptionData(subscription_data);

        if (subscription_data.subscription_status === "trial") {
          setTrialUser(true);
        }

        if (subscription_data.subscription_status === "paid") {
          if (subscription_data?.stripe_status === "canceled") {
            if (subscription_data?.end_date <= getUnixTime(new Date())) {
              setTrialUser(true);
            }

            // if (subscription_data?.isandroid || subscription_data?.isios) {
            //   setTrialUser(true);
            // }
          }
          const invoiceRes = await postApi(
            { querystring: "get_invoice_details" },
            "subscription",
          );
          console.log("invoiceRes", invoiceRes);
          if (invoiceRes.success) {
            const {
              subscription_payment_data,
              equipment_subscription_payment_data,
            } = invoiceRes;
            legacyFlag = !!subscription_payment_data?.is_legacy_pricing;
            setIsLegacyPricing(legacyFlag);
            setSubPaymentData(subscription_payment_data);
            setEquipmentSubscriptionData(equipment_subscription_payment_data);
            const invoiceData = invoiceRes.invoices;
            setInvoices(invoiceData);
            setReceipts(invoiceRes.charges);
          }

          const paymentMethodsRes = await postApi(
            { querystring: "get_payment_methods" },
            "subscription",
          );
          console.log("paymentMethodsRes", paymentMethodsRes);
          if (paymentMethodsRes.success) {
            const { data, equipment_data } = paymentMethodsRes;
            setPaymentData(data || null);
            setEquipmentPaymentData(equipment_data || null);
            console.log("equipment_data", equipment_data);
          }
        }
      }

      // const telematicsRes = await postApi(
      //   { querystring: "get_subscription_status" },
      //   "subscription"
      // );
      // if (telematicsRes.success) {
      //   setTelematicsData(telematicsRes.subscription);
      // }

      const priceDetailsRes = await postApi(
        {
          querystring: "get_price_deatils",
        },
        "subscription",
      );
      if (priceDetailsRes.success) {
        const { subscription, topup } = priceDetailsRes;
        const {
          advance_monthly_price,
          advance_yearly_price,
          advance_monthly_price_legacy,
          advance_yearly_price_legacy,
          currency,
          enterprice_price,
          enterprice_yearly_price,
          essential_monthly_price,
          essential_yearly_price,
          essential_monthly_price_legacy,
          essential_yearly_price_legacy,
          medium_price,
          medium_yearly_price,
          small_price,
          small_yearly_price,
        } = subscription;

        const initEssential = legacyFlag
          ? essential_monthly_price_legacy
          : essential_monthly_price;
        const initAdvanced = legacyFlag
          ? advance_monthly_price_legacy
          : advance_monthly_price;

        setPerVehiclePrice({
          essential: initEssential,
          advanced: initAdvanced,
        });

        setTotalPrice({
          essential: initEssential * noOfVehicles,
          advanced: initAdvanced * noOfVehicles,
        });

        setPriceDetailsData(subscription);

        // Store top-up price details for passing to TopUpCreditsModal
        if (topup) {
          setTopUpPriceDetails({
            pricePerCredit: topup.price,
            currency: topup.currency,
          });
        }
      }
    } catch (error) {
      console.error("Error in billingCalls:", error);
    } finally {
      setLoading(false);
    }
  };

  const pollForNewPlan = async (maxAttempts = 8, intervalMs = 3000) => {
    setLoading(true);
    for (let i = 0; i < maxAttempts; i++) {
      await new Promise((res) => setTimeout(res, intervalMs));
      try {
        const subRes = await postApi(
          { querystring: "get_subscription_status" },
          "subscription",
        );
        if (subRes.success) {
          const { success, ...subscription_data } = subRes;
          if (subscription_data.subscription_status === "paid") {
            await billingCalls();
            return;
          }
        }
      } catch (e) {
        console.error("Polling error:", e);
      }
    }
    // Fallback: load whatever state the backend has
    await billingCalls();
  };

  // Effect to verify payment for is_topup
  useEffect(() => {
    const sessionId = query.get("session_id");

    if (!sessionId || !is_topup || !isLoggedIn || !status) return;

    // Check status first before verifyPayment
    if (status === "failed") {
      setPaymentProcessingData({
        message: t("payment_failed"),
        icon: { className: "fi fi-rr-cross-circle", color: "red" },
      });
      setIsProcessing(false);
      setShowPaymentProcessingPopup(true);
      return;
    }

    // Only proceed with verifyPayment if status is success or not provided
    if (status && status !== "success") return;

    const verifyPayment = async (attempt = 0) => {
      try {
        const res = await postApi(
          { querystring: "verify_payment", session_id: sessionId },
          "subscription",
        );
        console.log("verifyPayment res", res);

        if (res.success) {
          const { data } = res;
          const { payment_status, payment_intent_status, last_payment_error } =
            data;

          // Case 1: Payment is successful
          if (
            payment_status === "paid" ||
            payment_intent_status === "succeeded"
          ) {
            setPaymentProcessingData({
              message: t("top_up_credits_success_msg"),
              icon: { className: "fi fi-rs-check-circle", color: "green" },
            });
            setIsProcessing(false);
            setShowPaymentProcessingPopup(true);
            return;
          }

          // Case 2: Payment failed
          if (
            payment_status === "failed" ||
            payment_intent_status === "requires_payment_method"
          ) {
            setPaymentProcessingData({
              message: last_payment_error || t("payment_failed"),
              icon: { className: "fi fi-rr-cross-circle", color: "red" },
            });
            setIsProcessing(false);
            setShowPaymentProcessingPopup(true);
            return;
          }

          // Case 3: Payment is processing
          if (payment_intent_status === "processing") {
            if (attempt < 3) {
              // Show loader and processing message, then retry
              setPaymentProcessingData({
                message: t("payment_processing"),
                icon: { className: "fi fi-rs-loader", color: "blue" },
              });
              setIsProcessing(true);
              setShowPaymentProcessingPopup(true);

              // Retry after 5 seconds
              setTimeout(() => verifyPayment(attempt + 1), 5000);
            } else {
              // After 3 attempts, show generic processing message without loader
              setPaymentProcessingData({
                message: t("payment_processing_generic"),
                icon: { className: "fi fi-rs-clock", color: "orange" },
              });
              setIsProcessing(false);
              setShowPaymentProcessingPopup(true);
            }
            return;
          }

          // Case 4: Any other payment_intent_status - show failure
          setPaymentProcessingData({
            message: t("payment_verification_failed"),
            icon: { className: "fi fi-rr-cross-circle", color: "red" },
          });
          setIsProcessing(false);
          setShowPaymentProcessingPopup(true);
        } else {
          // API call failed
          setPaymentProcessingData({
            message: t("payment_verification_failed"),
            icon: { className: "fi fi-rr-cross-circle", color: "red" },
          });
          setIsProcessing(false);
          setShowPaymentProcessingPopup(true);
        }
      } catch (err) {
        console.error("Payment verification error:", err);
        setPaymentProcessingData({
          message: t("payment_verification_failed"),
          icon: { className: "fi fi-rr-cross-circle", color: "red" },
        });
        setIsProcessing(false);
        setShowPaymentProcessingPopup(true);
      }
    };

    // Start payment verification
    verifyPayment();
  }, [is_topup, isLoggedIn, query, status, t]);

  //Effect to set Loading to false
  // useEffect(() => {
  //   if (subscriptionData) {
  //     const { subscription_status } = subscriptionData;
  //     if (subscription_status === "paid") {
  //       if (priceDetailsData) {
  //         setLoading(false);
  //       }
  //     } else {
  //       if (priceDetailsData) {
  //         setLoading(false);
  //       }
  //     }
  //   }
  // }, [subscriptionData, priceDetailsData]);

  //Efffect to change totalPrice on change of noOfVehicles
  // useEffect(() => {
  //   let vehicles = noOfVehicles <= 5 ? 5 : noOfVehicles;

  //     setTotalPrice((prev) => {
  //       let temp = { ...prev };
  //       temp.essential = prev.essential * vehicles;
  //       temp.advanced = prev.advanced * vehicles;
  //       return temp;
  //     });

  //     setTotalPrice({ essential:  })

  // }, [noOfVehicles]);

  //Effect to change price per vehicle on change of monthly/yearly toggle plans
  useEffect(() => {
    if (priceDetailsData) {
      let vehicles = noOfVehicles <= 5 ? 5 : noOfVehicles;
      const {
        advance_monthly_price,
        advance_yearly_price,
        advance_monthly_price_legacy,
        advance_yearly_price_legacy,
        essential_monthly_price,
        essential_yearly_price,
        essential_monthly_price_legacy,
        essential_yearly_price_legacy,
      } = priceDetailsData;

      const essentialMonthly = isLegacyPricing
        ? essential_monthly_price_legacy
        : essential_monthly_price;
      const essentialYearly = isLegacyPricing
        ? essential_yearly_price_legacy
        : essential_yearly_price;
      const advanceMonthly = isLegacyPricing
        ? advance_monthly_price_legacy
        : advance_monthly_price;
      const advanceYearly = isLegacyPricing
        ? advance_yearly_price_legacy
        : advance_yearly_price;

      if (toggleValue === "monthly") {
        setPerVehiclePrice({
          essential: essentialMonthly,
          advanced: advanceMonthly,
        });
        setTotalPrice({
          essential: essentialMonthly * vehicles,
          advanced: advanceMonthly * vehicles,
        });
      } else {
        setPerVehiclePrice({
          essential: essentialYearly,
          advanced: advanceYearly,
        });
        setTotalPrice({
          essential: essentialYearly * vehicles,
          advanced: advanceYearly * vehicles,
        });
      }
    }
  }, [toggleValue, noOfVehicles, isLegacyPricing]);

  // const handleToggleChange = (e) => {
  //   setToggleValue(e.currentTarget.value);
  // };

  return (
    <>
      {showSubscriptionPopup && (
        <InfoPopup
          showPopup={showSubscriptionPopup}
          setShowPopup={setShowSubscriptionPopup}
          message={subscriptionPopupData?.message}
          icon={subscriptionPopupData?.icon}
          actionIcon={{
            handler: () => {
              setShowSubscriptionPopup(false);
              removeQueryParams("status");
            },
            label: t("ok"),
          }}
        />
      )}

      {showPaymentProcessingPopup && (
        <PaymentProcessingPopup
          showPopup={showPaymentProcessingPopup}
          setShowPopup={setShowPaymentProcessingPopup}
          message={paymentProcessingData?.message}
          icon={paymentProcessingData?.icon}
          isLoading={isProcessing}
          processingMessage={t("payment_processing")}
          actionIcon={{
            handler: () => {
              setShowPaymentProcessingPopup(false);
              removeQueryParams("session_id", "is_topup", "status");
            },
            label: t("ok"),
          }}
        />
      )}
      <Container>
        <Row
          className="pb-3 pt-1 px-1 d-flex align-items-center justify-content-around"
          //style={{ background: "white", position: "sticky", top: 0 }}
        >
          <Col>
            <ColumnHeading>{t("billing")}</ColumnHeading>
          </Col>
        </Row>
        <Card>
          <CardBody style={{ background: "#f5f5f5" }}>
            {loading ? (
              <div
                className="text-center"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "70vh",
                }}
              >
                <TableSpinner animation="border" />
              </div>
            ) : trialUser ? (
              <NewPlan
                priceDetailsData={priceDetailsData}
                totalPrice={totalPrice}
                perVehiclePrice={perVehiclePrice}
                noOfVehicles={noOfVehicles}
                setNoOfVehicles={setNoOfVehicles}
                toggleValue={toggleValue}
                setToggleValue={setToggleValue}
                subscriptionData={subscriptionData}
              />
            ) : (
              <ExistingPlan
                paymentData={paymentData}
                priceDetailsData={priceDetailsData}
                topUpPriceDetails={topUpPriceDetails}
                invoices={invoices}
                receipts={receipts}
                subscriptionData={subscriptionData}
                perVehiclePrice={perVehiclePrice}
                toggleValue={toggleValue}
                subPaymentData={subPaymentData}
                equipmentSubscriptionData={equipmentSubscriptionData}
                equipmentPaymentData={equipmentPaymentData}
                pollSubscriptionStatus={pollSubscriptionStatus}
                isLegacyPricing={isLegacyPricing}
                //telematicsData={telematicsData}
              />
            )}
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default Billing;

export const RightIcon = (
  <i
    className="fi fi-rs-check-circle"
    style={{ color: "green", position: "relative", top: 2 }}
  />
);

export const WrongIcon = (
  <i
    className="fi fi-rr-cross-circle"
    style={{ color: "red", position: "relative", top: 2 }}
  />
);

//styles
export const BoldSpan = styled.span`
  font-weight: 600;
`;

export const NormalSpan = styled.span`
  font-weight: 400;
`;
